import AbstractPlatformUpdater, {
    LatestOperatorApplicationVersion
} from "~/operatorApplication/ts/platform/AbstractPlatformUpdater";
import {ElectronIPCRendererInstance} from "~/ts/library/electron/ipc/ElectronIPCRenderer";
import {
    OPERATOR_ELECTRON_APPLY_UPDATE,
    OPERATOR_ELECTRON_FETCH_UPDATE,
    OPERATOR_ELECTRON_GET_APP_BRAND,
    OPERATOR_ELECTRON_GET_APP_VERSION,
    OPERATOR_ELECTRON_GET_OS_ARCH,
    OperatorElectionFetchUpdateInterface
} from "~/operatorApplication/electron/src/ipc/ElectronIpcActionsConstant";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {internationalUrlIfNeeded, STATIC_SERVER} from "~/core-ui/ts/Constants";
import ElectronPlatform from "~/operatorApplication/electron/src/ElectronPlatform";
import axios from "axios";

export default abstract class AbstractElectronPlatformUpdater extends AbstractPlatformUpdater {
    protected abstract get updateJsonFileName(): string;

    protected abstract get updateZipDirectory(): string;

    async getCurrentApplicationVersion(): Promise<string> {
        return await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_GET_APP_VERSION);
    }

    protected async getLatestVersion(): Promise<LatestOperatorApplicationVersion> {

        let url = internationalUrlIfNeeded(`${STATIC_SERVER}/API/DOCS/operatorApplication/${this.updateJsonFileName}`);
        return (await axios.get(url, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        })).data;
    }

    protected async getUpdateArchiveUrl(latestVersion: LatestOperatorApplicationVersion): Promise<string> {
        let fileName: string;
        if (ElectronPlatform.isWindows) {
            let osArch = await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_GET_OS_ARCH);
            fileName = `win-${osArch}`;
        } else if (ElectronPlatform.isMac) {
            fileName = `mac-${process.arch}`;
        } else if (ElectronPlatform.isLinux) {
            fileName = `linux`;
        }

        //let fileName = process.platform == "win32" ? "win" : `mac-${process.arch}`;

        let brandId = await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_GET_APP_BRAND);

        if (process.versions.electron === latestVersion.electronVersion) {
            fileName += "-partial";
        }

        return internationalUrlIfNeeded(`${OperatorApplicationConfigInstance.staticServer}/API/DOCS/operatorApplication/builds/${latestVersion.version}/${this.updateZipDirectory}/${brandId}/${fileName}.zip?t=${Date.now()}`);
    }

    protected async downloadUpdateToApplicationRoot(url: string): Promise<boolean> {
        let isPartial = url.indexOf("-partial") != -1;
        let payload: OperatorElectionFetchUpdateInterface = {
            isPartial,
            url
        };
        return await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_FETCH_UPDATE, payload);
    }

    async make(): Promise<void> {
        await ElectronIPCRendererInstance.invoke(OPERATOR_ELECTRON_APPLY_UPDATE);
    }
}